import { Component, input, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { controlChanges } from '../../forms/control-changes';
import { ErrorDisplayer } from '../error-displayer/error-displayer';

@Component({
  selector: 'app-vc-input',
  imports: [ReactiveFormsModule, TranslatePipe, ErrorDisplayer],
  templateUrl: './vc-input.html',
  styleUrl: './vc-input.scss',
})
export class VcInput {
  readonly control = input.required<FormControl<string>>();
  readonly name = input.required<string>();
  readonly label = input.required<string>();
  readonly placeholder = input('');
  readonly type = input('text');
  readonly required = input(false);
  readonly autocomplete = input('off');
  /** Text shown after the field, e.g. `.vouchercart.com`. */
  readonly suffix = input<string>();
  readonly tooltipKey = input<string>();
  readonly maxLengthMessage = input<string>();
  readonly hideErrors = input(false);

  readonly enter = output();
  readonly valueChange = output<string>();
  readonly focused = output<boolean>();
  readonly blurred = output();

  protected readonly hasFocus = signal(false);
  private readonly changes = controlChanges(this.control);

  protected hasError() {
    this.changes();
    return this.control().touched && this.control().invalid;
  }

  protected showDomainExistError() {
    this.changes();
    return this.name() === 'domain' && this.control().hasError('domainExist');
  }

  protected onFocus() {
    this.hasFocus.set(true);
    this.focused.emit(true);
  }

  protected onBlur(event: Event) {
    this.hasFocus.set(false);
    if ((event.target as HTMLInputElement).value === '') {
      this.control().setValue('');
    }
    this.focused.emit(false);
    this.blurred.emit();
  }

  protected onInput(event: Event) {
    this.valueChange.emit((event.target as HTMLInputElement).value);
  }

  protected onEnter(event: Event) {
    this.enter.emit();
    (event.target as HTMLInputElement).blur();
  }
}
